<template>
	<div class="recharge">
		<div class="content">
			<div class="card">
				<div class="user">
					<div class="title">账户可用余额（元）</div>
					<div class="handle">
						<div class="num">{{balance}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="block"></div>
		<Form class="form" label-position="top">
			<FormItem label="提现金额">
				<Input class="input" @input="specifiName($event)" placeholder="请输入金额" v-model="formItem.money"></Input>
			</FormItem>
			<FormItem label="提现方式">
				<tabNav :list="payTypeList" v-model="formItem.method"></tabNav>
			</FormItem>
			<FormItem label="持卡人姓名" v-if="formItem.method==3">
				<Input class="input" maxlength="6" placeholder="请输入真实姓名" v-model="formItem.account_name"></Input>
			</FormItem>
			<FormItem label="银行卡号" v-if="formItem.method==3">
				<Input class="input" maxlength="24" placeholder="请输入银行卡号" v-model="formItem.card_number"></Input>
			</FormItem>
			<FormItem label="银行名称" v-if="formItem.method==3">
				<Input class="input" maxlength="12" placeholder="请输入银行名称" v-model="formItem.card_bankname"></Input>
			</FormItem>
			<FormItem label="开户行" v-if="formItem.method==3">
				<Input class="input" maxlength="20" placeholder="请输入开户行" v-model="formItem.card_open_bank"></Input>
			</FormItem>
			<FormItem label="收款账户名" v-if="formItem.method!=3">
				<Input class="input" maxlength="8" placeholder="请输入账户名" v-model="formItem.account_name"></Input>
			</FormItem>

			<FormItem label="收款账号" v-if="formItem.method!=3">
				<Input class="input" maxlength="32" placeholder="请输入收款账号" v-model="formItem.account"></Input>
			</FormItem>
			<div class="footer">
				<div class="total">提现手续费: {{formItem.withdrawal_rate}}%</div>
				<div class="total" style="margin-left: 10px;">到账金额: ￥{{formItem.real_money}}</div>
				<Button class="pay-btn" type="primary" :loading="submitting" :disabled="submitting" @click="payment()" style="width: 100px">立即提交</Button>
			</div>
		</Form>
	</div>
</template>

<script>
	import tabNav from '../../components/tabNav'
	import paymentAlert from "../../components/payment-alert";
	export default {
		name: 'withdrawal',
		components: {
			tabNav
		},
		data() {
			return {
				balance: 0,
				submitting: false,
				timer: null,
				page: 'platform',
				formItem: this.getDefaultFormItem(),
				payTypeList: [
					{
						value: 2,
						label: '支付宝'
					},
				]
			}
		},
		created() {
			let vm = this
			vm.init()
		},

		methods: {
			getDefaultFormItem(withdrawalRate = 0) {
				return {
					method: 2,
					real_money: 0,
					withdrawal_rate: withdrawalRate,
					money: "",
					account_name: "",
					account: "",
					card_number: "",
					card_bankname: "",
					card_open_bank: ""
				}
			},
			resetWithdrawalForm() {
				const withdrawalRate = this.formItem.withdrawal_rate
				this.formItem = this.getDefaultFormItem(withdrawalRate)
			},
			init() {
				let vm = this
				this.$request('610a83f23f8f4', {}).then(res => {
					vm.balance = res.data.data.balance
				})
				this.$request('64a284b977b6a', {}).then(res => {
					vm.formItem.withdrawal_rate = res.data.data.withdrawal_hand_fee
				})
			},
			specifiName(value) {
				let vm = this
				value = parseFloat(value)
				if (!Number.isFinite(value)) {
					vm.formItem.real_money = 0
					return
				}
				const withdrawalRate = parseFloat(vm.formItem.withdrawal_rate) || 0
				vm.formItem.real_money = (value - value * withdrawalRate / 100).toFixed(2)
			},
			async payment() {
				let vm = this
				if (vm.submitting) return
				if (!vm.formItem.money) {
					return this.$message.error('请输入提现金额')
				}
				if(vm.formItem.money<=0){
					return this.$message.error('提现金额需要大于0')

				}
				if (this.formItem.method == 3) {
					if (!vm.formItem.account_name) {
						return this.$message.error('请输入持卡人姓名')
					}
					if (!vm.formItem.card_number) {
						return this.$message.error('请输入银行卡号')
					}
					if (!vm.formItem.card_bankname) {
						return this.$message.error('请输入银行名称')
					}
				} else {
					if (!vm.formItem.account_name) {
						return this.$message.error('请输入收款账户名')
					}
					if (!vm.formItem.account) {
						return this.$message.error('请输入收款账号')
					}
				}

				const submitParams = { ...vm.formItem }
				console.log('[withdrawal submit params]', submitParams)
				vm.submitting = true
				try {
					await this.$request('610a8a50978fe', submitParams)
					this.$message.success('操作成功')
					this.resetWithdrawalForm()
					this.init()
				} finally {
					vm.submitting = false
				}
			},
			clickDetail() {
				console.log(123)
			}
		}
	}
</script>

<style lang="less">
	.recharge {
		.ivu-steps-title {
			margin-top: 2px;
		}

		.content {
			background-color: #FFFFFF;
		}

		.card {
			display: flex;
			justify-content: space-between;
			padding: 20px 10px;

			.user {
				min-width: 300px;
				height: 80px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title {
					font-size: 18px;
					color: #333;
					font-weight: 700;
				}

				.handle {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.num {
						font-size: 24px;
						color: #333;
					}

					.btn-view {
						margin-left: 60px;

						.recharge {
							margin-right: 10px;
						}
					}
				}
			}

			.total {
				display: flex;
				align-items: center;

				.total-item {
					width: 120px;

					.title {
						font-size: 12px;
						color: rgb(102, 102, 102);
						letter-spacing: 0;
						line-height: 1;
					}

					.num {
						font-size: 28px;
						color: rgb(17, 17, 17);
						letter-spacing: 0;
						line-height: 1;
						margin-top: 10px;
					}
				}
			}


		}

		.block {
			width: 100%;
			height: 15px;
			background-color: #f7f8fa;
		}

		.form {
			padding-left: 10px;
			margin-top: 30px;

			.input {
				width: 300px;
			}

			.tips {
				color: #999999;
				font-size: 12px;
				margin-bottom: 30px;
			}

			.footer {
				display: flex;
				align-items: center;
				margin-top: 30px;
				margin-bottom: 20px;

				.pay-btn {
					margin-left: 30px;
				}
			}
		}

	}
</style>
